<template>
   <div class="layout">
      <NuxtPage />
   </div>
</template>
<script setup lang="ts"></script>
